import { createAction, props } from '@ngrx/store';

export const projectList = createAction('PROJECT_LIST', props<{items: any}>());
export const projectCreate = createAction('PROJECT_CREATE', props<{item: any}>());
export const projectUpdate = createAction('PROJECT_UPDATE', props<{item: any}>());
export const projectDelete = createAction('PROJECT_DELETE', props<{item: any}>());
